/**
 * IDs are drawn from Confluence to match "Item"
 * https://weathergroup.atlassian.net/wiki/spaces/WEX/pages/2329280567/My+Weather+-+Home
 * Internationalization JSON properties should also match these (refer to myWeatherPage.json)
 */
export const dailyWeatherPageTestIDs = {
  dailyWeatherPage: 'daily_weather_page',
  dailyWeatherTiles: 'daily_weather_page_tiles',
  todayWeatherTile: 'daily_weather_page_today_weather_tile',
  tomorrowWeatherTile: 'daily_weather_page_tomorrow_weather_tile',
  dayAfterTomorrowWeatherTile: 'daily_weather_page_day_after_tomorrow_weather_tile',
  dayThreeWeatherTile: 'daily_weather_page_day_three_weather_tile',
  dayFourWeatherTile: 'daily_weather_page_day_four_weather_tile',
  dayFiveWeatherTile: 'daily_weather_page_day_five_weather_tile',
  daySixWeatherTile: 'daily_weather_page_day_six_weather_tile',
  dailyHeaderLabel: 'daily_weather_page_header_label',
  dailyHeaderLocation: 'daily_weather_page_header_location',
  dailyHeaderTimeStamp: 'daily_weather_page_header_timeStamp',
  pipWidget: 'daily_weather_picture_in_picture_widget',
  dailyWeatherTopRow: 'daily_weather_page_top_row',
  dailyWeatherMiddleRowToday: 'daily_weather_middle_row_today',
  dailyWeatherMiddleRowTomorrow: 'daily_weather_middle_row_tomorrow',
  dailyWeatherBottomRow: 'daily_weather_bottom_row',
};
